import { createAction } from '@reduxjs/toolkit'

export type TestEnvironmentVariant = 'prod' | 'test'

export type TSetTestEnvironment = {
  variant: TestEnvironmentVariant
}

export const initialize = createAction<TSetTestEnvironment>(
  'initialize_test_environment'
)

export const update = createAction<TSetTestEnvironment>(
  'update_test_environment'
)
